<template>
    <VJoyWrapper>
        <VJoyWrapper class="favorite-list-skeleton__name" no-margin direction="column" row-gap="1">
            <VJoyFormFieldSkeleton size="xxsmall" />
            <VJoyFormFieldSkeleton size="xxsmall" />
        </VJoyWrapper>
        <VJoyFormFieldSkeleton size="medium" width="60%" />
        <VJoyFormFieldSkeleton size="medium" width="10%" />
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {VJoyFormFieldSkeleton, VJoyWrapper} from '@maltjoy/core-vue';
</script>

<style lang="scss" scoped>
    .favorite-list-skeleton {
        &__name {
            flex: 1 0 auto;
        }
    }
</style>
